import type { ArticleSection } from "@/mocks/beauty-info";

export default function ArticleBody({ sections }: { sections: ArticleSection[] }) {
  return (
    <div className="flex flex-col gap-10 md:gap-12">
      {sections.map((section, index) => (
        <section key={index} className="flex flex-col gap-4">
          {section.heading && (
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 leading-snug flex items-start gap-3">
              <span className="mt-2 shrink-0 w-1.5 h-5 rounded-full bg-primary-500"></span>
              {section.heading}
            </h2>
          )}
          <div className="flex flex-col gap-4">
            {section.paragraphs.map((paragraph, pIndex) => (
              <p
                key={pIndex}
                className="text-[15px] md:text-base text-foreground-700 leading-[1.9]"
              >
                {paragraph}
              </p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}